import { Component, Input, ContentChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-spotlight',
  templateUrl: './spotlight.component.html',
  standalone: false,
})
export class SpotlightComponent {
  @Input() title: string = '';
  @ContentChild('body') body: TemplateRef<any>;
  @ContentChild('footer') footer: TemplateRef<any>;

  constructor() {
    this.body = TemplateRef.prototype;
    this.footer = TemplateRef.prototype;
  }
}
